<template>
  <div class="home pt-3">
    <transition
      name="animate-route"
      mode="out-in"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <article-list :articles="articles" />
    </transition>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import ArticleList from "@/components/ArticleList/ArticleList"

@Component({
  components: {
    ArticleList
  }
})
export default class Home extends Vue {
  get articles() {
    return this.$store.state.article.articles;
  }
}
</script>
